import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Company = Loadable(lazy(() => import('./Company')));
const CompanyIntegrations = Loadable(lazy(() => import('./CompanyIntegrations')));
const Tax = Loadable(lazy(() => import('./Tax')));
const RestrictionPage = Loadable(lazy(() => import('./RestrictionPage')));

const dashboardRoutes = [
  { path: '/dashboard/integrations', element: <CompanyIntegrations /> },
  { path: '/dashboard/company', element: <Company />, auth: authRoles.admin },
  { path: '/dashboard/tax', element: <Tax />, auth: authRoles.admin },
  { path: '/dashboard/restrictions', element: <RestrictionPage />, auth: authRoles.admin },
];

export default dashboardRoutes;
